import React, {useState} from 'react';
import {ImageListItem, LinearProgressWithLabel, Button} from '../../../ui-library';
import {ContainerBox, ContainerBoxUploadBtn, UploadBtn, NumOfImagesIcon, ErrorBox, AlertOutlined, AlertFull, ImageListNewCLass} from '../Style/NewClassImages.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {IProps} from '../Config/NewClassImages.types';
import useNewClassImages from '../Controllers/useNewClassImages.controller';
import HoverImageBox from './HoverImageBox.view';
import LoadDataBtn from '../../../Presentational Components/LoadDataBtn';
import uploadIcon from '../../../images/upload_blue.png';
import {ImageUrl} from '../../ImageUrl';
import AutoClassGalleryView from '../../AutoClassGallery/View/AutoClassGallery.view';
import {IMAGE_STATUS} from '../../../Custom Hooks/useUploadProcess/useUploadProcess.constants';
import { FLOW } from '../../../pages/RandomSampler/Config/RandomSampler.constants';

const NewClassImages = ({itemData, numberOfFiles, numberOfSuccess, onDeleteFile, getChosenFiles, uiFiledFileList, retryAllFiledFiles, uploadClassError, getOpen}:IProps) => {
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState({});
    const [currentImageIndex, setCurrentImageIndex] = useState(-1);
    const {activeHover, onMouseOverImage, onMouseOverContainer} = useNewClassImages(open, getOpen);
    const progressValue = (numberOfSuccess / numberOfFiles) * 100;

    return (
        <ContainerBox onMouseOver={(e) => onMouseOverContainer && onMouseOverContainer(e)}>
            <ContainerBoxUploadBtn>
                <LoadDataBtn
                    classNameBtn=''
                    accept='image/*'
                    btnTitle={_SYSTEM_TITLES.upload}
                    multiple={true}
                    onUploadFiles={(e) => getChosenFiles(e.target.files)}
                    uploadImageSrc={uploadIcon}
                    uploadOnlyOneFile={() => {}} >
                    <UploadBtn variant='outlined' size='large' >{_SYSTEM_TITLES.upload}</UploadBtn>
                </LoadDataBtn>
                <NumOfImagesIcon />
                {numberOfFiles > 0 &&
                    <LinearProgressWithLabel
                        numerator={numberOfSuccess}
                        denominator={numberOfFiles}
                        value={progressValue > 100 ? 100 : progressValue}
                        width={132}
                    />
                }
            </ContainerBoxUploadBtn>
            {uploadClassError && <AlertFull severity='error' >{uploadClassError}</AlertFull>}
            {uiFiledFileList.length > 0 && <AlertOutlined variant='outlined' severity='error' action={
                <Button onClick={retryAllFiledFiles} color='inherit' size='small'>
                    Retry
                </Button>
            }>
                {`Failed to upload ${uiFiledFileList.length} images`}
            </AlertOutlined>}
            <AutoClassGalleryView
                itemData={itemData}
                onDeleteFile={onDeleteFile}
                chosenImage={currentImage}
                open={open}
                setOpen={setOpen}
                currentImageIndex={currentImageIndex}
                setCurrentImageIndex={setCurrentImageIndex}
                setCurrentImage={setCurrentImage}
                flow={FLOW.classImages}
            />
            <ImageListNewCLass gap={7} cols={7} rowHeight={88}>
                {itemData.map((img) => (
                    <ImageListItem cols={1} key={img.title}>
                        {img.status === IMAGE_STATUS.FAILED && <ErrorBox />}
                        {activeHover === img.title && (img.status === IMAGE_STATUS.DONE || img.status === IMAGE_STATUS.VERIFY_FAILED) && <HoverImageBox onDeleteFile={() => onDeleteFile(img)} itemData={itemData}
                            chosenImage={img} open={open} setOpen={setOpen} setCurrentImage={setCurrentImage} setCurrentImageIndex={setCurrentImageIndex}/>}
                        <ImageUrl isAspectRatio={false} onMouseOver={onMouseOverImage} img={img} isLoadImageOutSide={img.status === IMAGE_STATUS.DONE || img.status === IMAGE_STATUS.VERIFY_FAILED} flow={FLOW.classList} />
                    </ImageListItem>
                ))}
            </ImageListNewCLass>
        </ContainerBox>
    );
};

export default NewClassImages;
